/**
 * =====================================================
 * ISOFIN® FEUCHTE-ANALYSE - SSOT DIAGNOSE ENGINE v2.1
 * =====================================================
 * 
 * Kapillar-Confidence-Score (0-100%)
 * 
 * v2.1:
 * - Q2 = Early-Stage Wahrnehmung (Options statt Slider)
 * - Q3 = Verlauf (Kapillar-Signatur)
 * - Q4 = Salz/Ablagerungen
 * - Q6 = Zeit/Wetter, Q7 = Alter, Q8 = Material
 * - Safety Gate: min 2 Evidenzen für "Kapillar"
 * - productFit referenziert q8 (Material)
 * 
 * STABIL HALTEN!
 * 
 * @version 2.1.0
 */

(function() {
  'use strict';

  var SSOT = {};

  // ===== ERGEBNIS-TYPEN =====
  var TYPES = {
    KAPILLAR: 'kapillar',
    KAPILLAR_PLUS: 'kapillar_plus',
    SEITLICH: 'seitlich',
    KONDENSAT: 'kondensat',
    DRUCKWASSER: 'druckwasser',
    UNKLAR: 'unklar'
  };

  var CONFIDENCE = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
  };

  // ===== SCORING-GEWICHTE =====

  var WEIGHTS = {

    // --- Q1: Freies Wasser (Ausschluss) ---
    q1: {
      active_yes: { kapillar: -12, druckwasser: 9, leitung: 5 },
      active_no:  { kapillar: 2 }
    },

    // --- Q2: Wahrnehmung / Early-Stage ---
    q2: {
      smell_only:        { kapillar: 1, kondensat: 2 },
      cold_clammy:       { kapillar: 1, kondensat: 1 },
      wont_dry:          { kapillar: 3 },
      dark_permanent:    { kapillar: 2 },
      plaster_damage:    { kapillar: 3, kondensat: 1 },
      unsure_perception: { kapillar: 0 }
    },

    // --- Q3: Verlauf (Kapillar-Signatur) ---
    q3: {
      bottom_band:    { kapillar: 3, seitlich: 1 },
      bottom_knee:    { kapillar: 5 },
      bottom_hip:     { kapillar: 3, seitlich: 2 },
      middle_or_spot: { kapillar: -1, seitlich: 3, druckwasser: 1 },
      everywhere:     { kapillar: -1, kondensat: 2, seitlich: 2 }
    },

    // --- Q4: Salz / Ablagerungen (stark) ---
    q4: {
      mineral_powder:  { kapillar: 6 },
      mineral_crystal: { kapillar: 7 },
      mineral_no:      { kapillar: 0 },
      mineral_unsure:  { kapillar: 0 }
    },

    // --- Q5: Lage im Gebäude ---
    q5: {
      basement:     { kapillar: 3, seitlich: 2 },
      ground_floor: { kapillar: 4 },
      upper_floor:  { kapillar: -5, kondensat: 3, leitung: 2 }
    },

    // --- Q6: Zeit / Wetter ---
    q6: {
      always:         { kapillar: 3 },
      after_rain:     { kapillar: -1, seitlich: 3, druckwasser: 2 },
      humid_days:     { kapillar: -2, kondensat: 5 },
      sudden:         { kapillar: -3, leitung: 5 },
      unsure_weather: { kapillar: 0 }
    },

    // --- Q7: Gebäudealter ---
    q7: {
      pre_1930:          { kapillar: 4 },
      between_1930_1970: { kapillar: 3 },
      between_1970_2000: { kapillar: 1 },
      after_2000:        { kapillar: 0, leitung: 1 },
      unknown_age:       { kapillar: 1 }
    },

    // --- Q8: Wandtyp ---
    q8: {
      brick:            { kapillar: 2 },
      natural_stone:    { kapillar: 2 },
      hollow_block:     { kapillar: 1 },
      concrete:         { kapillar: 0 },
      unknown_material: { kapillar: 1 }
    }
  };

  // ===== SCORING ENGINE =====

  function calculateScores(answers) {
    var scores = {
      kapillar: 0,
      kondensat: 0,
      seitlich: 0,
      druckwasser: 0,
      leitung: 0
    };

    // Q1
    if (answers.q1 && WEIGHTS.q1[answers.q1]) {
      applyWeights(scores, WEIGHTS.q1[answers.q1]);
    }

    // Q2-Q8 (Option-Codes)
    ['q2','q3','q4','q5','q6','q7','q8'].forEach(function(qKey) {
      var val = answers[qKey];
      if (val && WEIGHTS[qKey] && WEIGHTS[qKey][val]) {
        applyWeights(scores, WEIGHTS[qKey][val]);
      }
    });

    return scores;
  }

  function applyWeights(scores, weights) {
    Object.keys(weights).forEach(function(key) {
      if (scores.hasOwnProperty(key)) {
        scores[key] += weights[key];
      }
    });
  }

  // ===== HARD OVERRIDES =====

  function checkOverrides(answers, scores) {

    // Override 1: Aktiver Zufluss → Druckwasser/Leitung
    if (answers.q1 === 'active_yes') {
      return {
        type: TYPES.DRUCKWASSER,
        confidence: CONFIDENCE.HIGH,
        kapillarScore: scores.kapillar,
        override: 'OVR_ACTIVE_FLOW',
        description: 'Aktiver Wasserzufluss / frei bewegliches Wasser'
      };
    }

    // Override 2: Kondensat-Trifecta
    if (answers.q6 === 'humid_days' &&
        answers.q3 === 'everywhere' &&
        answers.q5 === 'upper_floor') {
      return {
        type: TYPES.KONDENSAT,
        confidence: CONFIDENCE.HIGH,
        kapillarScore: scores.kapillar,
        override: 'OVR_KONDENSAT',
        description: 'Klassisches Kondensat-Muster'
      };
    }

    // Override 3: Plötzlich + OG = Leitung
    if (answers.q6 === 'sudden' && answers.q5 === 'upper_floor') {
      return {
        type: TYPES.DRUCKWASSER,
        confidence: CONFIDENCE.MEDIUM,
        kapillarScore: scores.kapillar,
        override: 'OVR_LEITUNG',
        description: 'Pl\u00f6tzlicher Schaden im Obergeschoss \u2192 Leitungsverdacht'
      };
    }

    return null;
  }

  // ===== KAPILLAR-CONFIDENCE =====

  function kapillarConfidence(kapillarScore) {
    var s = Math.max(0, Math.min(32, kapillarScore));
    var pct = Math.round((s / 32) * 100);
    return Math.max(0, Math.min(100, pct));
  }

  function confidenceLevel(pct) {
    if (pct >= 55) return CONFIDENCE.HIGH;
    if (pct >= 25) return CONFIDENCE.MEDIUM;
    return CONFIDENCE.LOW;
  }

  // ===== SAFETY GATE =====
  // Mindestens 2 harte Evidenzen nötig für "Kapillar" bei hohem Score.
  // Verhindert false positives wenn nur weiche Signale kommen.

  function capillaryEvidenceCount(answers) {
    var n = 0;

    // Muster (Verlauf)
    if (answers.q3 === 'bottom_band' || answers.q3 === 'bottom_knee' || answers.q3 === 'bottom_hip') n++;

    // Salz
    if (answers.q4 === 'mineral_powder' || answers.q4 === 'mineral_crystal') n++;

    // Erdbezug
    if (answers.q5 === 'basement' || answers.q5 === 'ground_floor') n++;

    // Dauerhaftigkeit
    if (answers.q6 === 'always') n++;

    // Altbau (schwächerer Marker)
    if (answers.q7 === 'pre_1930' || answers.q7 === 'between_1930_1970') n++;

    return n;
  }

  // ===== ERGEBNIS-TYP =====

  function determineType(answers, scores, kapPct) {
    var kapScore = scores.kapillar;
    var seitScore = scores.seitlich || 0;
    var ev = capillaryEvidenceCount(answers);

    // ── Ausschluss: klarer Druckwasser-Verdacht → nur Hendrik ──
    // Stehendes Wasser, Wasser durch Risse, Rohrbruch = Druckwasser
    if (answers.q1 === 'active_yes') return TYPES.DRUCKWASSER;

    // ── Kondensat-Trifecta bleibt als Override ──
    if (scores.kondensat >= 8 && kapPct < 30) return TYPES.KONDENSAT;

    // ── v395 (Björn, 06.07.): Vollflächig + Keller = seitliches Eindringen über
    //    die erdberührte Fläche → IMMER Flächensperre. Vorher hat angeklicktes
    //    Salz (q4) diesen Weg blockiert (Schwelle B unten) und der sichere
    //    Kapillar-Pfad hat ihn als kapillar_plus auf die aufsteigende Seite
    //    geroutet. Salz gibt es aber bei beiden Feuchte-Arten. Druckwasser-
    //    Override und Kondensat-Gate (oben) bleiben bewusst davor. ──
    if (answers.q3 === 'everywhere' && answers.q5 === 'basement') return TYPES.SEITLICH;

    // ── v397 (Björn): Obergeschoss = »ohne Erdkontakt« → weder Horizontal-
    //    noch Flächensperre passt (kein Erdbezug; Regen-Signal = eher
    //    Schlagregen/Fassade). Immer Hendrik-Exit (unklar-Text). Druckwasser-/
    //    Leitungs-/Kondensat-Overrides oben greifen weiterhin zuerst. ──
    if (answers.q5 === 'upper_floor') return TYPES.UNKLAR;

    // ── v397 (Björn): Punktuell/mitten in der Wand + Keller = seitlich, auch
    //    mit Salz (gleiche Salz-Blockade wie beim v395-Fall; punktuell mittig
    //    ist kein Aufsteig-Muster). ──
    if (answers.q3 === 'middle_or_spot' && answers.q5 === 'basement') return TYPES.SEITLICH;

    // ── Alles andere: voraussichtlich Kapillar → weiterleiten ──
    // Hoher Score + Evidenz → Kapillar (sicher)
    if (kapPct >= 55 && ev >= 2) {
      if (seitScore >= 4 && answers.q5 === 'basement') return TYPES.KAPILLAR_PLUS;
      return TYPES.KAPILLAR;
    }

    // Mittlerer/niedriger Score → trotzdem als wahrscheinlich Kapillar weiterleiten
    // (Entsch\u00e4rft: kein "UNKLAR" mehr, immer weiter zur Wanddaten-Eingabe)
    // Seitliches Eindringen (v312.8, Schwelle B): klares Seitlich-Signal OHNE die
    // Kapillar-Fingerabdruecke. seitScore >= 4 und WEDER Salz (q4) NOCH klassisches
    // Aufsteig-Muster unten (q3 bottom_*). Bewusst NICHT gegen den Roh-kapScore
    // verglichen (der ist durch Baujahr/Material/Lage aufgeblaeht und wuerde echte
    // Seitlich-Faelle in alten/erdberuehrten Gebaeuden verschlucken). Kein sicherer
    // Kapillar-Fall (siehe oben) -> eigener Ausgang auf die seitliche Loesungsseite.
    // (Vorher als kapillar_plus -> aufsteigende gelabelt; 'seitlich'-Routing war tot.)
    var _hasSalt = (answers.q4 === 'mineral_powder' || answers.q4 === 'mineral_crystal');
    var _risingPattern = (answers.q3 === 'bottom_band' || answers.q3 === 'bottom_knee' || answers.q3 === 'bottom_hip');
    if (seitScore >= 4 && !_hasSalt && !_risingPattern) return TYPES.SEITLICH;
    return TYPES.KAPILLAR;
  }

  // ===== REASONS =====

  function buildReasons(answers) {
    var reasons = [];

    // Q1
    if (answers.q1 === 'active_no') reasons.push('Kein frei bewegliches Wasser sichtbar');
    if (answers.q1 === 'active_yes') reasons.push('Tropfen/Flie\u00dfen/Pf\u00fctzen beobachtet');

    // Q2 Wahrnehmung
    if (answers.q2 === 'smell_only') reasons.push('Muffiger Geruch (ohne klare Sichtzeichen)');
    if (answers.q2 === 'cold_clammy') reasons.push('Wand wirkt kalt/klamm');
    if (answers.q2 === 'wont_dry') reasons.push('Stelle trocknet nicht ab');
    if (answers.q2 === 'dark_permanent') reasons.push('Dauerhaft dunkle Oberfl\u00e4che');
    if (answers.q2 === 'plaster_damage') reasons.push('Putz/Anstrich zeigt Sch\u00e4den');

    // Q3 Verlauf
    if (answers.q3 === 'bottom_band') reasons.push('Unten st\u00e4rker, nach oben weniger');
    if (answers.q3 === 'bottom_knee') reasons.push('Bis Knieh\u00f6he betroffen');
    if (answers.q3 === 'bottom_hip') reasons.push('Bis H\u00fcfth\u00f6he oder h\u00f6her betroffen');
    if (answers.q3 === 'middle_or_spot') reasons.push('Punktuell / mitten in der Wand');
    if (answers.q3 === 'everywhere') reasons.push('Gro\u00dffl\u00e4chig gleichm\u00e4\u00dfig');

    // Q4 Mineralische Rückstände
    if (answers.q4 === 'mineral_powder') reasons.push('Pulvrige Ablagerungen sichtbar');
    if (answers.q4 === 'mineral_crystal') reasons.push('Kristallartige Ausbl\u00fchungen sichtbar');

    // Q5 Lage
    if (answers.q5 === 'basement') reasons.push('Keller / unter Erdniveau');
    if (answers.q5 === 'ground_floor') reasons.push('Erdgeschoss');
    if (answers.q5 === 'upper_floor') reasons.push('Obergeschoss / ohne Erdkontakt');

    // Q6 Wetter/Zeit
    if (answers.q6 === 'always') reasons.push('Dauerhaft vorhanden');
    if (answers.q6 === 'after_rain') reasons.push('Nach Regen st\u00e4rker');
    if (answers.q6 === 'humid_days') reasons.push('An schw\u00fclen Tagen st\u00e4rker');
    if (answers.q6 === 'sudden') reasons.push('Pl\u00f6tzlich aufgetreten');

    // Q7 Alter
    if (answers.q7 === 'pre_1930') reasons.push('Baujahr vor 1930');
    if (answers.q7 === 'between_1930_1970') reasons.push('Baujahr 1930\u20131970');

    // Q8 Material
    if (answers.q8 === 'brick') reasons.push('Ziegel/Klinker/Kalksandstein');
    if (answers.q8 === 'natural_stone') reasons.push('Naturstein/Bruchstein');
    if (answers.q8 === 'concrete') reasons.push('Beton');

    return reasons;
  }

  // ===== PRODUKTEIGNUNG =====

  function productFit(answers) {
    var fit = {
      suitable: true,
      notes: [],
      bohrAbstand: '25 cm'
    };

    if (answers.q8 === 'concrete') {
      fit.notes.push('Normbeton: Bohrlochabstand auf 12,5 cm halbieren');
      fit.bohrAbstand = '12,5 cm';
    }
    if (answers.q8 === 'natural_stone') {
      fit.notes.push('Naturstein: Wirkung l\u00e4uft prim\u00e4r \u00fcber Fugen/M\u00f6rtel');
    }
    if (answers.q8 === 'hollow_block') {
      fit.notes.push('Hohlblock: Verteilung in Hohlkammern m\u00f6glich \u2013 Verbrauch kann variieren');
    }

    return fit;
  }

  // ===== HAUPTFUNKTION =====

  SSOT.evaluate = function(answers) {
    if (!answers || typeof answers !== 'object') {
      return {
        type: TYPES.UNKLAR,
        confidence: CONFIDENCE.LOW,
        kapillarPct: 0,
        scores: {},
        reasons: [],
        error: 'Keine Antworten'
      };
    }

    var scores = calculateScores(answers);

    // Hard Overrides
    var override = checkOverrides(answers, scores);
    if (override) {
      override.scores = scores;
      override.reasons = buildReasons(answers);
      override.kapillarPct = kapillarConfidence(scores.kapillar);
      override.productFit = productFit(answers);
      return override;
    }

    // Kapillar-Confidence
    var kapPct = kapillarConfidence(scores.kapillar);
    var confLevel = confidenceLevel(kapPct);

    // Ergebnis-Typ (mit Safety Gate)
    var type = determineType(answers, scores, kapPct);

    return {
      type: type,
      confidence: confLevel,
      kapillarPct: kapPct,
      kapillarScore: scores.kapillar,
      scores: scores,
      reasons: buildReasons(answers),
      override: false,
      productFit: productFit(answers)
    };
  };

  // ===== DEBUG =====

  SSOT.debug = function(answers) {
    var scores = calculateScores(answers);
    var kapPct = kapillarConfidence(scores.kapillar);
    return {
      answers: answers,
      scores: scores,
      kapillarPct: kapPct,
      confidence: confidenceLevel(kapPct),
      type: determineType(answers, scores, kapPct),
      evidenceCount: capillaryEvidenceCount(answers),
      productFit: productFit(answers)
    };
  };

  // =====================================================
  // V2 SCORING ENGINE — Dynamischer Diagnose-Flow
  // =====================================================
  // - 5 Kernfragen (v2q1–v2q5), optionale + Keller-Branch
  // - Kapillar aufgesplittet: aufsteigend + lateral
  // - Early-Exit via evaluatePartial()
  // - Alte evaluate() bleibt für Rückwärtskompatibilität

  var TYPES_V2 = {
    KAPILLAR_AUFSTEIGEND: 'kapillar_aufsteigend',
    KAPILLAR_LATERAL: 'kapillar_lateral',
    KONDENSAT: 'kondensat',
    DRUCKWASSER: 'druckwasser',
    LEITUNG: 'leitung',
    UNKLAR: 'unklar'
  };

  // --- V2 Kernfragen-Reihenfolge ---
  var V2_CORE = ['v2q1','v2q2','v2q3','v2q4','v2q5'];
  var V2_OPTIONAL = ['v2q6'];
  var V2_KELLER = ['v2k1','v2k2','v2k3','v2k4'];

  // --- V2 SCORING-GEWICHTE ---
  var WEIGHTS_V2 = {

    // v2q1: Gibt es aktives Wasser? (= altes Q1)
    v2q1: {
      active_yes: { kap_auf: -12, kap_lat: -8, druckwasser: 9, leitung: 5 },
      active_no:  { kap_auf: 2, kap_lat: 1 }
    },

    // v2q2: Wie verläuft der Schaden optisch? (NEU, breiter als altes Q3)
    v2q2: {
      unten_weniger:     { kap_auf: 6 },                              // unten stärker, nach oben weniger
      kniehoehe:         { kap_auf: 7 },                              // bis Kniehöhe ~30-80cm
      huefthoehe:        { kap_auf: 4, kap_lat: 2 },                  // bis Hüfthöhe ~80-150cm
      seitlich_ecke:     { kap_auf: 1, kap_lat: 6 },                  // von einer Seite/Ecke kommend
      punktuell:         { kap_auf: -1, kap_lat: 3, druckwasser: 2 }, // punktuell an Anschluss
      grossflaechig:     { kap_auf: -2, kap_lat: -1, kondensat: 4 },  // großflächig gleichmäßig
      unsure_pattern:    { kap_auf: 0, kap_lat: 0 }
    },

    // v2q3: Wo liegt die betroffene Wand? (erweitert)
    v2q3: {
      keller:    { kap_auf: 3, kap_lat: 4 },
      eg:        { kap_auf: 5, kap_lat: 1 },
      og:        { kap_auf: -6, kap_lat: -4, kondensat: 4, leitung: 2 },
      hanglage:  { kap_auf: 2, kap_lat: 5 },
      unsicher:  { kap_auf: 0, kap_lat: 0 }
    },

    // v2q4: Wie verhält sich die Feuchtigkeit zeitlich? (= altes Q6)
    v2q4: {
      dauerhaft:     { kap_auf: 4, kap_lat: 3 },
      nach_regen:    { kap_auf: -1, kap_lat: 4, druckwasser: 2 },
      schwuel:       { kap_auf: -3, kap_lat: -2, kondensat: 6 },
      ploetzlich:    { kap_auf: -4, kap_lat: -3, leitung: 6 },
      unsicher_zeit: { kap_auf: 0, kap_lat: 0 }
    },

    // v2q5: Gibt es Ausblühungen / Ablagerungen? (= altes Q4)
    v2q5: {
      pulvrig:       { kap_auf: 6, kap_lat: 4 },
      kristall:      { kap_auf: 7, kap_lat: 5 },
      nein:          { kap_auf: 0, kap_lat: 0 },
      unsicher_salz: { kap_auf: 0, kap_lat: 0 }
    },

    // v2q6: Vereinfachte Wahrnehmung (optional, nur bei Unsicherheit)
    v2q6: {
      trocknet_nicht: { kap_auf: 3, kap_lat: 2 },
      putz_loest:     { kap_auf: 3, kap_lat: 1 },
      klamm_muffig:   { kap_auf: 1, kondensat: 2 },
      unsicher_wahr:  { kap_auf: 0 }
    },

    // v2k1: Wo sitzt die Feuchte am stärksten? (Keller-Branch)
    v2k1: {
      aussenwand:     { kap_lat: 4 },
      ecke:           { kap_lat: 5 },
      boden_wand:     { kap_auf: 3, kap_lat: 3 },
      innenwand:      { kap_auf: 2, kap_lat: 1 },
      anschluss:      { kap_lat: 5 },
      unsicher_k1:    { kap_lat: 0 }
    },

    // v2k2: Angrenzender Eintrittsbereich?
    v2k2: {
      lichtschacht:   { kap_lat: 4 },
      treppe:         { kap_lat: 3 },
      nachbar:        { kap_lat: 3 },
      grundstueck:    { kap_lat: 2 },
      keine_bes:      { kap_lat: 0 },
      unsicher_k2:    { kap_lat: 0 }
    },

    // v2k3: Ist die Wand erdberührt / hangseitig?
    v2k3: {
      ja:         { kap_lat: 4 },
      nein_k3:    { kap_lat: -2, kap_auf: 1 },
      teilweise:  { kap_lat: 3 },
      unsicher_k3:{ kap_lat: 0 }
    },

    // v2k4: Flächig oder lokal?
    v2k4: {
      flaechig:    { kap_lat: 3 },
      lokal:       { kap_lat: 1, druckwasser: 1 },
      wechselt:    { kap_lat: 2 },
      unsicher_k4: { kap_lat: 0 }
    }
  };

  // --- V2 Score-Berechnung ---
  function calculateScoresV2(answers) {
    var scores = { kap_auf: 0, kap_lat: 0, kondensat: 0, druckwasser: 0, leitung: 0 };
    Object.keys(answers).forEach(function(qKey) {
      var val = answers[qKey];
      if (val && WEIGHTS_V2[qKey] && WEIGHTS_V2[qKey][val]) {
        applyWeights(scores, WEIGHTS_V2[qKey][val]);
      }
    });
    return scores;
  }

  // --- V2 Hard Overrides ---
  function checkOverridesV2(answers, scores) {
    // Override 1: Aktiver Zufluss
    if (answers.v2q1 === 'active_yes') {
      return { type: TYPES_V2.DRUCKWASSER, confidence: CONFIDENCE.HIGH, override: 'OVR_ACTIVE_FLOW',
        description: 'Aktiver Wasserzufluss / frei bewegliches Wasser' };
    }
    // Override 2: Kondensat-Trifecta
    if (answers.v2q4 === 'schwuel' && answers.v2q2 === 'grossflaechig' && answers.v2q3 === 'og') {
      return { type: TYPES_V2.KONDENSAT, confidence: CONFIDENCE.HIGH, override: 'OVR_KONDENSAT',
        description: 'Klassisches Kondensat-Muster (schw\u00fcl + gro\u00dffl\u00e4chig + Obergeschoss)' };
    }
    // Override 3: Plötzlich + OG = Leitung
    if (answers.v2q4 === 'ploetzlich' && answers.v2q3 === 'og') {
      return { type: TYPES_V2.LEITUNG, confidence: CONFIDENCE.MEDIUM, override: 'OVR_LEITUNG',
        description: 'Pl\u00f6tzlicher Schaden im Obergeschoss \u2192 Leitungsverdacht' };
    }
    return null;
  }

  // --- V2 Kapillar-Confidence (kombiniert aufsteigend + lateral) ---
  function kapillarConfidenceV2(scores) {
    var combined = Math.max(0, scores.kap_auf) + Math.max(0, scores.kap_lat);
    var maxPossible = 38; // Theoretisches Maximum bei optimalen Antworten
    var pct = Math.round((Math.min(combined, maxPossible) / maxPossible) * 100);
    return Math.max(0, Math.min(100, pct));
  }

  // --- V2 Evidenz-Zählung ---
  function capillaryEvidenceV2(answers) {
    var n = 0;
    // Muster (aufsteigend oder lateral)
    if (answers.v2q2 === 'unten_weniger' || answers.v2q2 === 'kniehoehe' || answers.v2q2 === 'huefthoehe') n++;
    if (answers.v2q2 === 'seitlich_ecke') n++;
    // Salz
    if (answers.v2q5 === 'pulvrig' || answers.v2q5 === 'kristall') n++;
    // Erdbezug
    if (answers.v2q3 === 'keller' || answers.v2q3 === 'eg' || answers.v2q3 === 'hanglage') n++;
    // Dauerhaftigkeit
    if (answers.v2q4 === 'dauerhaft') n++;
    // Keller-Evidenz
    if (answers.v2k1 === 'aussenwand' || answers.v2k1 === 'ecke' || answers.v2k1 === 'anschluss') n++;
    if (answers.v2k3 === 'ja' || answers.v2k3 === 'teilweise') n++;
    return n;
  }

  // --- V2 Ergebnis-Typ ---
  function determineTypeV2(answers, scores, kapPct) {
    var aufScore = Math.max(0, scores.kap_auf);
    var latScore = Math.max(0, scores.kap_lat);
    var ev = capillaryEvidenceV2(answers);

    // Hoher kombinierter Score
    if (kapPct >= 55) {
      if (ev < 2) return TYPES_V2.UNKLAR;
      if (latScore > aufScore) return TYPES_V2.KAPILLAR_LATERAL;
      return TYPES_V2.KAPILLAR_AUFSTEIGEND;
    }

    // Mittlerer Score
    if (kapPct >= 35) {
      if (scores.kondensat > (aufScore + latScore)) return TYPES_V2.KONDENSAT;
      if (latScore > aufScore && latScore >= 4) return TYPES_V2.KAPILLAR_LATERAL;
      if (aufScore >= 4) return TYPES_V2.KAPILLAR_AUFSTEIGEND;
      return TYPES_V2.UNKLAR;
    }

    // Niedriger Score
    var maxAlt = Math.max(scores.kondensat, scores.druckwasser + scores.leitung);
    if (scores.kondensat === maxAlt && scores.kondensat >= 4) return TYPES_V2.KONDENSAT;
    if ((scores.druckwasser + scores.leitung) >= 4) return TYPES_V2.DRUCKWASSER;

    return TYPES_V2.UNKLAR;
  }

  // --- V2 Reasons ---
  function buildReasonsV2(answers) {
    var reasons = [];
    if (answers.v2q1 === 'active_no') reasons.push('Kein frei bewegliches Wasser');
    if (answers.v2q1 === 'active_yes') reasons.push('Aktives Wasser beobachtet');
    if (answers.v2q2 === 'unten_weniger') reasons.push('Unten st\u00e4rker, nach oben weniger');
    if (answers.v2q2 === 'kniehoehe') reasons.push('Bis Knieh\u00f6he betroffen');
    if (answers.v2q2 === 'huefthoehe') reasons.push('Bis H\u00fcfth\u00f6he oder h\u00f6her');
    if (answers.v2q2 === 'seitlich_ecke') reasons.push('Von einer Seite / Ecke kommend');
    if (answers.v2q2 === 'punktuell') reasons.push('Punktuell an Anschluss / \u00dcbergang');
    if (answers.v2q2 === 'grossflaechig') reasons.push('Gro\u00dffl\u00e4chig gleichm\u00e4\u00dfig');
    if (answers.v2q3 === 'keller') reasons.push('Keller / unter Erdniveau');
    if (answers.v2q3 === 'eg') reasons.push('Erdgeschoss');
    if (answers.v2q3 === 'og') reasons.push('Obergeschoss');
    if (answers.v2q3 === 'hanglage') reasons.push('Hanglage / teilweise unter Erdreich');
    if (answers.v2q4 === 'dauerhaft') reasons.push('Dauerhaft vorhanden');
    if (answers.v2q4 === 'nach_regen') reasons.push('Nach Regen st\u00e4rker');
    if (answers.v2q4 === 'schwuel') reasons.push('An schw\u00fclen Tagen st\u00e4rker');
    if (answers.v2q4 === 'ploetzlich') reasons.push('Pl\u00f6tzlich aufgetreten');
    if (answers.v2q5 === 'pulvrig') reasons.push('Pulvrige Ablagerungen');
    if (answers.v2q5 === 'kristall') reasons.push('Kristallartige Ausbl\u00fchungen');
    if (answers.v2q6 === 'trocknet_nicht') reasons.push('Stelle trocknet nicht ab');
    if (answers.v2q6 === 'putz_loest') reasons.push('Putz / Farbe l\u00f6st sich');
    // Keller-Branch
    if (answers.v2k1 === 'aussenwand') reasons.push('Feuchte an Au\u00dfenwand');
    if (answers.v2k1 === 'ecke') reasons.push('Feuchte in einer Ecke');
    if (answers.v2k1 === 'anschluss') reasons.push('Feuchte an Anschluss/\u00dcbergang');
    if (answers.v2k3 === 'ja') reasons.push('Wand ist erdber\u00fchrt');
    if (answers.v2k3 === 'teilweise') reasons.push('Wand teilweise erdber\u00fchrt');
    return reasons;
  }

  // ===== V2 HAUPTFUNKTIONEN =====

  /**
   * evaluatePartial — Prüft nach jeder Antwort ob Early-Exit möglich ist
   * @param {object} answers - Bisherige Antworten (unvollständig erlaubt)
   * @returns {{ canExit: boolean, exitType: string|null, confidence: string, kapPct: number, needsKeller: boolean }}
   */
  SSOT.evaluatePartial = function(answers) {
    if (!answers || typeof answers !== 'object') return { canExit: false, exitType: null, confidence: CONFIDENCE.LOW, kapPct: 0, needsKeller: false };

    var scores = calculateScoresV2(answers);
    var kapPct = kapillarConfidenceV2(scores);

    // Hard overrides = sofortiger Exit
    var ovr = checkOverridesV2(answers, scores);
    if (ovr) return { canExit: true, exitType: ovr.type, confidence: ovr.confidence, kapPct: kapPct, needsKeller: false, override: ovr.override };

    // Mindestens 3 Kernfragen beantwortet?
    var answered = V2_CORE.filter(function(q) { return answers[q] != null; }).length;
    if (answered < 3) return { canExit: false, exitType: null, confidence: CONFIDENCE.LOW, kapPct: kapPct, needsKeller: false };

    var ev = capillaryEvidenceV2(answers);

    // Klares Kapillar-Muster (hoch + genug Evidenz)
    if (kapPct >= 70 && ev >= 3) {
      var type = (scores.kap_lat > scores.kap_auf) ? TYPES_V2.KAPILLAR_LATERAL : TYPES_V2.KAPILLAR_AUFSTEIGEND;
      return { canExit: true, exitType: type, confidence: CONFIDENCE.HIGH, kapPct: kapPct, needsKeller: false };
    }

    // Klares Gegen-Muster
    if (scores.kondensat >= 8 && kapPct < 30) return { canExit: true, exitType: TYPES_V2.KONDENSAT, confidence: CONFIDENCE.HIGH, kapPct: kapPct, needsKeller: false };
    if ((scores.druckwasser + scores.leitung) >= 8 && kapPct < 20) return { canExit: true, exitType: TYPES_V2.DRUCKWASSER, confidence: CONFIDENCE.HIGH, kapPct: kapPct, needsKeller: false };

    // Keller/Lateral-Verdacht → Branch empfehlen
    var needsKeller = (answers.v2q3 === 'keller' || answers.v2q3 === 'hanglage') &&
                      (answers.v2q2 === 'seitlich_ecke' || answers.v2q2 === 'punktuell' || scores.kap_lat >= 4);

    return { canExit: false, exitType: null, confidence: confidenceLevel(kapPct), kapPct: kapPct, needsKeller: needsKeller };
  };

  /**
   * evaluateV2 — Vollständige V2-Bewertung (nach allen Fragen)
   * @param {object} answers - Alle V2-Antworten
   * @returns {object} Ergebnis im gleichen Format wie evaluate()
   */
  SSOT.evaluateV2 = function(answers) {
    if (!answers || typeof answers !== 'object') {
      return { type: TYPES_V2.UNKLAR, confidence: CONFIDENCE.LOW, kapillarPct: 0, scores: {}, reasons: [], error: 'Keine Antworten' };
    }

    var scores = calculateScoresV2(answers);

    // Hard Overrides
    var override = checkOverridesV2(answers, scores);
    if (override) {
      override.scores = scores;
      override.reasons = buildReasonsV2(answers);
      override.kapillarPct = kapillarConfidenceV2(scores);
      return override;
    }

    var kapPct = kapillarConfidenceV2(scores);
    var confLevel = confidenceLevel(kapPct);
    var type = determineTypeV2(answers, scores, kapPct);

    return {
      type: type,
      confidence: confLevel,
      kapillarPct: kapPct,
      kapillarAufsteigend: Math.max(0, scores.kap_auf),
      kapillarLateral: Math.max(0, scores.kap_lat),
      scores: scores,
      reasons: buildReasonsV2(answers),
      override: false,
      evidenceCount: capillaryEvidenceV2(answers)
    };
  };

  /**
   * getNextQuestion — Bestimmt die nächste Frage basierend auf bisherigen Antworten
   * @param {object} answers - Bisherige Antworten
   * @returns {{ questionId: string|null, phase: string, progress: number }}
   */
  SSOT.getNextQuestion = function(answers) {
    answers = answers || {};

    // Phase 1: Kernfragen (v2q1-v2q5)
    for (var i = 0; i < V2_CORE.length; i++) {
      if (answers[V2_CORE[i]] == null) {
        return { questionId: V2_CORE[i], phase: 'kern', progress: Math.round((i / V2_CORE.length) * 70) };
      }
    }

    // Early-Exit prüfen
    var partial = SSOT.evaluatePartial(answers);
    if (partial.canExit) return { questionId: null, phase: 'done', progress: 100 };

    // Keller-Branch?
    if (partial.needsKeller) {
      for (var k = 0; k < V2_KELLER.length; k++) {
        if (answers[V2_KELLER[k]] == null) {
          return { questionId: V2_KELLER[k], phase: 'keller', progress: 70 + Math.round((k / V2_KELLER.length) * 25) };
        }
      }
    }

    // Optionale Frage bei Unsicherheit
    if (partial.confidence === CONFIDENCE.LOW || partial.confidence === CONFIDENCE.MEDIUM) {
      for (var o = 0; o < V2_OPTIONAL.length; o++) {
        if (answers[V2_OPTIONAL[o]] == null) {
          return { questionId: V2_OPTIONAL[o], phase: 'optional', progress: 85 };
        }
      }
    }

    // Alle Fragen beantwortet
    return { questionId: null, phase: 'done', progress: 100 };
  };

  // ===== EXPORT =====

  SSOT.TYPES = TYPES;
  SSOT.TYPES_V2 = TYPES_V2;
  SSOT.CONFIDENCE = CONFIDENCE;
  SSOT.V2_CORE = V2_CORE;
  SSOT.V2_KELLER = V2_KELLER;
  SSOT.V2_OPTIONAL = V2_OPTIONAL;
  SSOT.productFit = productFit;

  window.FA_SSOT = SSOT;

})();
